export const team_members = [
    {
        image: "/images/team/MeysamArababadi.jpg",
        name: "میثم عرب آبادی",
        position: "هم بنیانگذار و مدیرعامل",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/meysamarababadi/",
            },
        ],
    },
    {
        image: "/images/team/kianooshAryanfar.jpg",
        name: "کیانوش آریانفر",
        position: "هم‌بنیان‌گذار و معاون محصول",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/kianoosh-aryanfar/",
            },
        ],
    },
    {
        image: "/images/team/SaeedParsaee.jpg",
        name: "سعید پارسایی",
        position: "معاون فنی",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/saeedparsaee/",
            },
        ],
    },
    {
        image: "/images/team/AmirRzaei.png",
        name: "امیر رضایی",
        position: "مدیرمحصول",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/amirezaei/",
            },
        ],
    },
    {
        image: "/images/team/AisaTamimi.jpg",
        name: "آیسا تمیمی",
        position: "هماهنگ کننده مارکتینگ",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/aisa-tamimi-360927249/",
            },
        ],
    },
    {
        image: "/images/team/NazaninAlishahi.png",
        name: "نازنین علیشاهی",
        position: "حسابدار",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/nazanin-alishahi-0a385237/",
            },
        ],
    },
    {
        image: "/images/team/NajmeGoroohi.png",
        name: "نجمه گروهء",
        position: "صدای مشتری",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/company/officialpinvest/",
            },
        ],
    },
    {
        image: "/images/team/SaeedYari.jpg",
        name: "آراز یاری",
        position: "توسعه دهنده سمت سرور",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/araazyari/",
            },
        ],
    },
    {
        image: "/images/team/AlirezaJabbari.jpg",
        name: "علیرضا جباری",
        position: "توسعه دهنده سمت سرور",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/alireza-jabari-kopaee/",
            },
        ],
    },
    {
        image: "/images/team/NargesFakour.jpg",
        name: "نرگس فکور",
        position: "توسعه دهنده سمت سرور",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/narges-fakour",
            },
        ],
    },
    {
        image: "/images/team/MojganRezaei.jpg",
        name: "مژگان رضایی",
        position: "توسعه دهنده سمت سرور",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/mojgan-rezaei-351049192/",
            },
        ],
    },
    {
        image: '/images/team/MohammadRezaShirani.png',
        name: 'محمدرضا شیرانی ',
        position: 'توسعه دهنده سمت سرور',
        about: '',
        socials: [
            {
                icon: 'pi-linkedin',
                url: 'https://www.linkedin.com/in/mohammad-reza-shirani-722358210/',
            },
        ],
    },
    {
        image: "/images/team/HamedFaryabi.jpg",
        name: "حامد فاریابی",
        position: "توسعه دهنده سمت کاربر",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/hamed-faryabi-17bb61106",
            },
        ],
    },
    {
        image: "/images/team/NafiseHaddadian.png",
        name: "نفیسه حدادیان",
        position: "توسعه دهنده سمت کاربر",
        about: "",
        socials: [
            {
                icon: "pi-linkedin",
                url: "https://www.linkedin.com/in/nafise-haddadian-7a0622214/",
            },
        ],
    },
];